export default __webpack_public_path__ + "static/media/ic-playlist-play-active.6b1e2bc5.svg";